<template>
    <div>    
        <div class="row">
            <div class="container container-fluid pesquisa">
                <alert :tipo="'alert-danger'" v-if="this.erroMsg != null">{{this.erroMsg}}</alert>
                <input type="text" v-model="campoRubrica" class="form-control campoPesquisa" placeholder="Digite o nome da rubrica ou seu código" aria-label="Username" aria-describedby="addon-wrapping"/>
                <button class="btn btn-primary botaoPesquisa" @click="buscar()">Filtrar</button>
                <button v-if="this.rubricasFiltro != null" class="btn btn-light botaoVoltar" @click="voltar()">Voltar</button>
            </div>
        </div>
        <div class="row" v-if="this.rubricasFiltro == null">
            <div class="container container-fluid">
                <table class="table table-bordered tabela">
                    <thead>
                        <tr>
                            <th class="tituloTabela" scope="col" colspan="4">Tabela de rubricas</th>
                        </tr>
                        <tr class="subtituloTabela">
                            <th scope="col" class="subTituloTabela colCodigo">Código</th>
                            <th scope="col" class="subTituloTabela colNome">Nome da Rubrica</th>
                            <th scope="col" class="subTituloTabela colDefinicao">Definição da Rubrica</th>
                            <th scope="col" class="subTituloTabela"></th>
                        </tr>
                    </thead>
                    <tbody>
                       <rubricas-lista id="itemlista" @codigoSelecionado="codigoSelecionado" v-for="rubricaL in rubricasLista" :rubricas="rubricaL" :key = "rubricaL.id"/>
                    </tbody>  
                </table>
            </div>
        </div>
        <div class="row" v-if="this.rubricasFiltro != null">
            <div class="container container-fluid">
                <table class="table table-bordered tabela">
                    <thead>
                        <tr>
                        <th class="tituloTabela" scope="col">Resultado da pesquisa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <rubricas-filtro id="itemFiltro" v-for="rubricaF in rubricasFiltro" :rubricas="rubricaF" :key = "rubricaF.id"/>
                    </tbody>  
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import alert from '../shared/alert.vue'
import rubricaItem from './rubricas-item.vue'
import rubricaAll from './rubricas-all.vue'
import rubricaServices from '../services/rubricasServices.js'

export default {
    components:{
        'rubricas-filtro': rubricaItem,
        'rubricas-lista': rubricaAll,
        'alert': alert
    },
    data(){
        return{
            campoRubrica: null,
            rubricasFiltro: null,
            rubricasLista: null,
            erroMsg: null
        }
    },
    methods:{
        buscar(){
            if(this.campoRubrica != null){
                this.erroMsg = null;
                this.service
                    .busca('pegaRubrica',this.campoRubrica)
                    .then(res => {
                        this.rubricasFiltro = res || []})
                    .then(()=>{
                        if(this.rubricasFiltro[0] == null || this.rubricasFiltro[0] == ''){
                            this.erroMsg = 'Dado não encontrado'
                        }else{
                            this.erroMsg = null
                        }
                    })
                    .then(()=>{
                        this.campoRubrica = null
                    })
            }else{
                this.erros()
            }
        },
        codigoSelecionado(payload){
            this.service
                .busca('pegaRubrica',payload.codigo)
                .then(res => {
                    this.rubricasFiltro = res || [];
                })
                .then(()=>{
                    if(this.rubricasFiltro[0] == null || this.rubricasFiltro[0] == ''){
                        this.erroMsg = 'Conteúdo não encontrado'
                    }else{
                        this.erroMsg = null
                    }
                })
        },
        voltar(){
            this.rubricasFiltro = null;
            this.erroMsg = null
        },
        erros(){
            if(this.campoRubrica == null){
                this.erroMsg = 'Campo vazio';
            }
        }
    },
    created(){
        this.service = new rubricaServices(this.$resource);
        this.service
            .lista('selecionaRubrica/rubricas/')
            .then(res => {
                this.rubricasLista = res;
            })
    }
}
</script>
<style scoped>
    .botaoVoltar{
        position: relative;
        top:-2.4em;
        left: 61rem;
    }
    .colNome{
        width: 19em;
    }
    .tabela{
        position: relative;
        left: 1em;   
    }
    .subTituloTabela{
        font-size: .9em;
        text-align: center;
    }
    .tituloTabela{
        text-align: center;
        font-size: 1.2em;
    }
    .campoPesquisa{
        width: 20rem;
        position: relative;
        /* left:4rem; */
        margin-right:1em;
        height: 2.4em;
    }
    .botaoPesquisa{
        position: relative;
        top: -2.4em;
        left: 20.5rem;
        height: 2.4em;
    }
    .pesquisa{
        margin-top: 3em;
        position: relative;
        left: 1em;
    }
    </style>





// WEBPACK FOOTER //
// src/components/rubricas-pesquisa.vue